module.exports = __webpack_public_path__ + "img/2.0a27da6e.png";